const getProductType = (productTypeFromGraph)=>{
    switch(productTypeFromGraph){
        case 'AccessoriesProduct':
            return 'accessories';
        case 'ContactLensProduct':
            return 'contact-lenses';
        case 'FrameProduct':
            return 'frames';
        case 'ReadyReaderProduct':
            return 'ready-readers';
        case 'SolutionProduct':
            return 'solutions';
        case 'SunglassesProduct':
            return 'sunglasses';
        default:
            return 'sunglasses';
    }
};

export { getProductType };
//# sourceMappingURL=get-shopping-list-product-type.js.map
